import { APIProvider } from '@vis.gl/react-google-maps';

import AddressTextFieldBase, {
  type AddressTextFieldBaseProps,
} from './AddressTextFieldBase';

export type AddressTextFieldProps = AddressTextFieldBaseProps & {
  googleMapsApiKey: string;
};

export default function AddressTextField({
  googleMapsApiKey,
  ...props
}: AddressTextFieldProps) {
  if (!googleMapsApiKey) {
    console.error('Google Maps API key is missing');
    return null;
  }

  return (
    <APIProvider apiKey={googleMapsApiKey}>
      <AddressTextFieldBase {...props} />
    </APIProvider>
  );
}
